import { ConnectedProps, connect } from "react-redux";
import { AppDispatch, RootState } from "store";
import { SlotsDetailTableContainerPropsType } from "./types";
import {
  slotSelector,
  actions,
  allslotsSelected,
  existCancelableSlots,
} from "reducers/slots";
import { SlotsFilterType } from "reducers/types/slots";
import { useCallback } from "react";
import SlotsDetailTable from "./SlotsDetailTable";
import { SlotsType } from "sagas/types/slots";
import { actions as slotDetailActions } from "reducers/slotDetailModal";

const SlotsDetailTableContainer = (
  props: SlotsDetailTableContainerPropsType & ConnectorProps
) => {
  const seeMoreSlots = useCallback(() => {
    props.getSlots({ ...props.filters, ...props.filtersExtraSeeMore });
  }, [props]);

  const isSelected = (itemId: number) =>
    props.slotsSelected?.map((slots) => slots.id).includes(itemId);

  const openModal = (value: boolean, slotId: number) => {
    props.getSlotDetail(slotId);
    props.openModal(value);
  };

  return (
    <SlotsDetailTable
      {...props}
      seeMoreSlots={seeMoreSlots}
      isSelected={isSelected}
      openModal={openModal}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  slots: slotSelector(state).slots,
  filters: slotSelector(state).filters,
  filtersExtraSeeMore: slotSelector(state).filtersExtraSeeMore,
  slotsSelected: slotSelector(state).slotsSelected,
  seeMore: slotSelector(state).seeMore,
  isAllSelected: allslotsSelected(state),
  enableCheck: existCancelableSlots(state),
  collapse: slotSelector(state).collapseTable,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getSlots: (params: SlotsFilterType) => {
    dispatch(actions.getSlotsRequest(params));
  },
  toggleItem: (item: SlotsType) => {
    dispatch(actions.toggleItem(item));
  },
  toggleAll: () => {
    dispatch(actions.toggleAll());
  },
  getSlotDetail: (id: number) => {
    dispatch(slotDetailActions.getSlotDetailRequest(id));
  },
});
const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(SlotsDetailTableContainer);
